import React from "react"
import { notifica } from "../requests/utils"
import { FormGroup, Col, Button, Row } from "reactstrap"
import Selectmultiple from "../components/Selectmultiple"
import moment from "moment"
class Filtros extends React.Component {
  constructor(props) {
    super(props)
    this.state = this.generaStates()
    this.selectAll = this.selectAll.bind(this)
    this.verReporte = this.verReporte.bind(this)
    this.filtraDatos = this.filtraDatos.bind(this)
    this.defineDatos = this.defineDatos.bind(this)
    this.cambioFecha = this.cambioFecha.bind(this)
    this.editaEstado = this.editaEstado.bind(this)
    this.childHandler = this.childHandler.bind(this)
    this.generaStates = this.generaStates.bind(this)
    this.generaFiltros = this.generaFiltros.bind(this)
    this.generaComponente = this.generaComponente.bind(this)
  }

  generaStates() {
    const { filtros } = this.props
    if (filtros) {
      var a = "{ "
      filtros.forEach((b) => {
        a += ' "' + b.variable + '": [],'
        a += ' "lbl_' + b.variable + '": null,'
      })
      a = a.substr(0, a.length - 1) + "}"
      return JSON.parse(a)
    }
  }

  componentDidMount() {
    const { filtros, datos } = this.props
    if (filtros) {
      filtros.forEach((f) => {
        var dts = datos.filter((d) => d.nombreVariable === f.variable),
          dtF = this.filtraDatos(dts, false)
        let state_default = this.getDefaultDatos(f.variable, dts)
        if (state_default) {
          this.setState({
            [`lbl_${f.variable}`]: state_default.substr(
              0,
              state_default.length - 1
            ),
          })
        }

        this.editaEstado(f.variable, dtF)
      })
      setTimeout(() => {
        this.verReporte(null)
      }, 3000)
    }
  }

  editaEstado(variable, dts) {
    this.setState({ [variable]: dts })
  }

  getDefaultDatos = (variable, datos) => {
    let str_ = `${variable}=`
    let isContainDeafult = false
    datos.forEach((x) => {
      str_ += x.valorPredeterminado ? `${x.idValor},` : ""
      if (x.valorPredeterminado) {
        isContainDeafult = true
      }
    })
    if (isContainDeafult) {
      return str_
    } else {
      return null
    }
  }

  filtraDatos(datos, estatus) {
    var cmb = []
    datos.forEach((x) => {
      let llave = x.valorAnterior
        ? `${x.idValor}°${x.valorAnterior}`
        : x.idValor
      cmb.push({
        id: llave,
        label: x.descripcionValor,
        value: x.valorPredeterminado,
        nuevo: true,
      })
    })
    return cmb
  }

  selectAll(e) {
    const { datos } = this.props
    var elm = e.target,
      nmvar = elm.getAttribute("variable"),
      ckd = elm.checked,
      dts = this.state[nmvar],
      datoA = datos.filter((d) => d.nombreVariable === nmvar)[0]
    dts.forEach((d) => {
      d.value = ckd
    })

    var sig = datoA.nombreVariableSig,
      lbl = document.getElementById("lbl_" + nmvar),
      dvS = document.getElementById("dv_sup_" + sig),
      sel = nmvar + "=",
      arr = []
    if (ckd) {
      dts.forEach((d) => {
        let id = d.id.indexOf("°") > -1 ? d.id.split("°")[0] : d.id
        sel += id + ","
        arr.push({ IdPadre: id })
      })

      sel = sel.substr(0, sel.length - 1)
      if (dvS !== null) {
        this.defineDatos(nmvar, arr, sig)
        dvS.classList.remove("Hide_All")
      }
    } else {
      sel = ""
      if (dvS !== null) {
        dvS.classList.add("Hide_All")
      }
    }
    lbl.innerText = sel
    this.editaEstado(nmvar, dts)
  }

  childHandler(datosHijo) {
    var lbl = document.getElementById("lbl_" + datosHijo.nombre),
      sig = lbl.getAttribute("sig"),
      dvS = document.getElementById("dv_sup_" + sig),
      sel = datosHijo.nombre + "=",
      arr = []
    datosHijo.datos.forEach((d) => {
      let id = d.id.indexOf("°") > -1 ? d.id.split("°")[0] : d.id

      sel += id + ","
      arr.push({ IdPadre: id })
    })
    if (datosHijo.datos.length > 0) {
      sel = sel.substr(0, sel.length - 1)
      this.defineDatos(datosHijo.nombre, arr, sig)
      if (dvS !== null) {
        dvS.classList.remove("Hide_All")
      }
    } else {
      sel = ""
      if (dvS !== null) {
        dvS.classList.add("Hide_All")
      }
    }
    lbl.innerText = sel
  }

  generaComponente(
    tipo,
    variable,
    Anterior,
    requerido,
    default_ = true,
    defaultValue = null
  ) {
    switch (tipo) {
      case "Fecha":
        return (
          <input
            type="date"
            className="form-control"
            name={variable}
            onChange={(e) => this.cambioFecha(e)}
            ant={Anterior}
            defaultValue={
              defaultValue ? moment(defaultValue).format("YYYY-MM-DD") : ""
            }
          />
        )
      case "Combo":
        return (
          <Selectmultiple
            datos={this.state[variable]}
            sencillo={false}
            action={this.childHandler}
            nombre={variable}
            ant={Anterior}
          />
        )
      case "ComboSencillo":
        return (
          <Selectmultiple
            datos={this.state[variable]}
            sencillo={true}
            action={this.childHandler}
            nombre={variable}
            ant={Anterior}
          />
        )
      default:
        break
    }
  }
  defineDatos(nombre, selcts, siguiente) {
    var dts = this.props.datos.filter(
        (d) => d.nombreVariable === siguiente && d.nombreVariableAnt === nombre
      ),
      arr = []

    selcts.forEach((s) => {
      var dtFltr = dts.filter((d) => d.valorAnterior === s.IdPadre)
      dtFltr.forEach((d) => {
        arr.push(d)
      })
    })
    var dtF = this.filtraDatos(arr, false)
    this.editaEstado(siguiente, dtF)
  }

  generaFiltros = () => {
    const { filtros } = this.props
    if (!filtros) return null

    return filtros.map((f, index) => {
      if (f.visible) {
        let class_check = "dv_min_Fltr"
        if (f.variable.includes("Fecha")) {
          class_check = "Hide_All"
        } else if (f.tipoDato === "ComboSencillo") {
          class_check = "Hide_All"
        }
        return (
          <Col
            sm={2}
            md={4}
            lg={3}
            className={
              f.visible
                ? f.Anterior === "No"
                  ? "frm_fltr"
                  : this.state[`lbl_${f.variable}`] !== undefined &&
                    this.state[`lbl_${f.variable}`] !== null &&
                    this.state[`lbl_${f.variable}`].length > 0
                  ? "frm_fltr"
                  : "frm_fltr Hide_All"
                : "frm_fltr Hide_All"
            }
            id={"dv_sup_" + f.variable}
            key={index}>
            <div className="dv_Btn_Lbl_Rpt">
              <div className="dv_min_Fltr_60">
                <label className="lbl_nmfltr">{f.filtro}</label>
              </div>
              <div className={class_check} style={{ marginBottom: 5 }}>
                <input
                  type="checkbox"
                  id={"chk_" + f.variable}
                  className={"check_all"}
                  variable={f.variable}
                  onChange={(e) => this.selectAll(e)}
                />
                <label htmlFor={"chk_" + f.variable}>
                  <span></span>
                </label>
                <label className="lbl_nmfltr">Todos</label>
              </div>
            </div>
            <br />
            <label
              id={"lbl_" + f.variable}
              className="lbl_filtros"
              sig={f.Siguiente}>
              {this.state[`lbl_${f.variable}`]}
            </label>
            {this.generaComponente(
              f.tipoDato,
              f.variable,
              f.Anterior,
              null,
              null,
              f.idValor
            )}
          </Col>
        )
      } else {
        return (
          <Col sm={2} md={2} lg={2} className="Hide_All" key={index}>
            <label
              id={`lbl_${f.variable}`}
              className="lbl_filtros"
              sig={f.Siguiente}>
              {this.state[`lbl_${f.variable}`] === null
                ? `${f.variable}=${f.idValor}`
                : this.state[`lbl_${f.variable}`]}
            </label>
          </Col>
        )
      }
    })
  }

  verReporte(e) {
    var lbls = document.querySelectorAll(".lbl_filtros"),
      fltr = "",
      vacio = false
    lbls.forEach((s) => {
      if (s.innerText.length === 0) {
        vacio = true
      }
      fltr += s.innerText + "&"
    })
    fltr = fltr.substr(0, fltr.length - 1)
    if (vacio) {
      notifica("warning", "Debes seleccionar todos los filtros", "Filtros")
    } else {
      var ur = this.props.datos[0]
      var dr = ur ? ur.urlReporte : ""
      fltr = fltr + "&Rpt=" + dr
      this.props.action(fltr, this.props.id)
    }
  }

  cambioFecha(e) {
    var elm = e.target,
      nm = elm.getAttribute("name"),
      lbl = document.getElementById("lbl_" + nm)
    lbl.innerText = nm + "=" + elm.value
  }

  render() {
    return (
      <div className="dv_fltr ml-3 mr-4">
        <FormGroup row>{this.generaFiltros()}</FormGroup>
        <Row className="mt-4">
          <Col className="d-flex justify-content-end">
            <Button
              color="primary"
              onClick={(r) => this.verReporte(r)}
              className={"btn-report"}>
              Ver Reporte
            </Button>
          </Col>
        </Row>
      </div>
    )
  }
}

export default Filtros
